import React, {Fragment, useContext} from 'react';
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import {ProviderRequestsContext} from "../../context/ProviderRequestsContext";
import {handleChangeFactory} from "../../utils/ProviderHandlerUtils";

export default function ChooseOptions(props) {
    const { classes } = props;
    const providerRequestsContext = useContext(ProviderRequestsContext);
    const selectedProviders = providerRequestsContext.state.selectedProviders;
    const handleChange = handleChangeFactory(providerRequestsContext.dispatch);

    const providerCategories =[
        {
            code: 'fotograf',
            name: 'Fotograf'
        },
        {
            code: 'cameraman',
            name: 'Cameraman'
        },
        {
            code: 'sonorizare',
            name: 'Sonorizare'
        },
        {
            code: 'organizatori',
            name: 'Event Planner'
        },
        {
            code: 'coafura-machiaj',
            name: 'Coafura și Machiaj'
        },
        {
            code: 'catering',
            name: 'Catering'
        }
    ];

    return (
        <Fragment>
            <Grid container spacing={2} noValidate className={`${classes.inputContainer} ${classes.mt56}`}>
                <Grid item xs={12} className={classes.noPadding}>
                    <Paper square elevation={0} className={classes.inputTitleContainer}>
                        <Typography className={classes.inputTitleText}>Ce servicii îți dorești la eveniment?</Typography>
                        <Typography className={`${classes.subTitle} ${classes.mb26}`}>Alege cel puțin un serviciu</Typography>
                    </Paper>

                    <FormControl>
                        <FormGroup row className={classes.checkboxContainer}>
                            {providerCategories.map((category) => (
                                <div className={classes.providerTypeContainer} key={category.code}>
                                    <FormControlLabel
                                        className={`${classes.checkboxSingle} ${selectedProviders.find(item => item.code === category.code) ? 'selected' : ''}`}
                                        key={category.code}
                                        control={
                                            <Checkbox
                                                className={classes.hideCheckbox}
                                                name={category.name}
                                                onChange={handleChange}
                                                value={category.code}
                                                key={category.code}
                                                color="primary"
                                            />
                                        }
                                        label={ <>{category.name}</> }
                                    />
                                </div>
                            ))}
                        </FormGroup>
                    </FormControl>
                </Grid>
            </Grid>
        </Fragment>
    )
}